import styled from "styled-components";

import { contentStyles } from "./contentStyles";

const ContentStyleHTML = styled.div`
    ${contentStyles}
`;

export const Content = styled(ContentStyleHTML).attrs(() => ({ className: "aevi-content" as string }))``;
